export var ProfileEnum;
(function (ProfileEnum) {
    ProfileEnum["REQUERENTE_PF"] = "REQUERENTE_PF";
    ProfileEnum["REQUERENTE_PJ"] = "REQUERENTE_PJ";
    ProfileEnum["PROCURADOR_PF"] = "PROCURADOR_PF";
    ProfileEnum["PROCURADOR_PJ"] = "PROCURADOR_PJ";
    ProfileEnum["INVENTARIANTE"] = "INVENTARIANTE";
    ProfileEnum["REPRESENTANTE_LEGAL"] = "REPRESENTANTE_LEGAL";
    ProfileEnum["RESPONSAVEL_TECNICO"] = "RESPONSAVEL_TECNICO";
    ProfileEnum["FALECIDO_INVENTARIANTE"] = "FALECIDO_INVENTARIANTE";
    ProfileEnum["CONJUGUE_REQUERENTE_PF"] = "CONJUGUE_REQUERENTE_PF";
    ProfileEnum["CONJUGUE_REPRESENTANTE"] = "CONJUGUE_REPRESENTANTE_LEGAL";
})(ProfileEnum || (ProfileEnum = {}));
(function (ProfileEnum) {
    var mapDescricao = new Map([
        [ProfileEnum.REQUERENTE_PF, 'Requerente'],
        [ProfileEnum.REQUERENTE_PJ, 'Requerente'],
        [ProfileEnum.PROCURADOR_PF, 'Procurador'],
        [ProfileEnum.PROCURADOR_PJ, 'Procurador'],
        [ProfileEnum.INVENTARIANTE, 'Inventariante'],
        [ProfileEnum.REPRESENTANTE_LEGAL, 'Representante Legal'],
        [ProfileEnum.RESPONSAVEL_TECNICO, 'Responsável Técnico'],
        [ProfileEnum.FALECIDO_INVENTARIANTE, 'Pessoa Falecida'],
        [ProfileEnum.CONJUGUE_REQUERENTE_PF, 'Cônjuge'],
        [ProfileEnum.CONJUGUE_REPRESENTANTE, 'Cônjuge'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    ProfileEnum.getDescricao = getDescricao;
})(ProfileEnum || (ProfileEnum = {}));
